import axios from 'axios'
import {urlText} from './common'
import {Toast} from 'vant';
import {getCodeFromUrl} from '@/assets/utils';


export function request(config) {
    const instance = axios.create({
        baseURL: process.env.NODE_ENV === 'development' ? '/api/dgut' : '/dgut',  //测试环境
        timeout: 20000
    })
    //  axios的拦截器
    //  请求拦截

    instance.interceptors.request.use((config) => {

        if (localStorage.getItem('authorization')) {
            config.headers['authorization'] = localStorage.getItem('authorization');
        }
        return config
    }, err => {
        console.log(err);
    })


    //  2.响应拦截
    instance.interceptors.response.use(res => {
        if (res.data.code == 401) {
            var ua = window.navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == 'micromessenger') {
                // alert(" 是来自微信内置浏览器")
               urlText()
            } else {
                const code = getCodeFromUrl()
                if (code) {
                    localStorage.setItem("authorization", code);
                    location.reload()
                } else {
                    urlText()
                }
            }
        }
        return res.data
    }, err => {
        if (err.message.includes('timeout')) {   // 判断请求异常信息中是否含有超时timeout字符串
            Toast('查询内容过多,请详细输入搜索内容')
            console.log("查询内容过多,请详细输入搜索内容");
        }
        console.log(err);
    })
    return instance(config)
}
